/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartBarsXUpIcon16Regular = forwardRef('DataChartBarsXUpIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M12 1.25a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-1.5 0V2a.75.75 0 0 1 .75-.75Z" }),
        React.createElement("path", { d: "M9.75 4a.75.75 0 0 0-1.5 0v7a.75.75 0 0 0 1.5 0V4Z" }),
        React.createElement("path", { d: "M6 5.25a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0V6A.75.75 0 0 1 6 5.25Z" }),
        React.createElement("path", { d: "M3 7.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V8A.75.75 0 0 1 3 7.25Z" }),
        React.createElement("path", { d: "M.75 13.25a.75.75 0 0 0 0 1.5h13.5a.75.75 0 0 0 0-1.5H.75Z" })));
});
